import TeacherService from '../../../modules/teacher/teacherService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'TEACHER_FORM'

const teacherFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: teacherFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await TeacherService.find(id)
      }

      dispatch({
        type: teacherFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: teacherFormActions.INIT_ERROR,
      })

      dispatch(push('/teacher'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: teacherFormActions.CREATE_STARTED,
      })

      await TeacherService.create(values)

      dispatch({
        type: teacherFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.teacher.create.success'),
      )

      dispatch(push('/teacher'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: teacherFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: teacherFormActions.UPDATE_STARTED,
      })

      await TeacherService.update(id, values)

      dispatch({
        type: teacherFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.teacher.update.success'),
      )

      dispatch(push('/teacher'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: teacherFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default teacherFormActions
